module.exports = function($) {
    class Menu{
        constructor(args){
            this.class_menu = args.class_menu;
            this.class_open_button = args.class_open_button;
            this.bind();
        }

        bind(){
            const _this = this;
            $(this.class_open_button + ', ' + this.class_close_button).on('click', function(e) {
                e.preventDefault();
                $('body').toggleClass('menuIsOpen');
                $(_this.class_menu).toggleClass('isOpen');
            });
            $('.menu-item-has-children > a').on('click', function(e){
                e.preventDefault();
                $(this).closest("li").toggleClass('active');
                $(this).closest("li").find('> .sub-menu').toggleClass("open");
            });
        }
    }

    new Menu({
        class_menu: ".main-menu",
        class_open_button: ".toggle-menu",
        class_close_button: ".close-menu",
    });

    document.addEventListener('DOMContentLoaded', function () {
        var languages = document.querySelector('.languages');

        languages.addEventListener('mouseenter', function () {
            languages.classList.add('active');
        });

        languages.addEventListener('mouseleave', function () {
            languages.classList.remove('active');
        });
    });

}





